import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import keycloakService from '../../keycloakService';
import { getJoyRideStatus, joyRideAttributeCreation } from '../../actions/userAction';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function HomeJoyRide(props) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const language = useSelector((state) => state.language).selectedLanguage;
  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
      updateSteps();
    }
  }, [language]);
  const [status, setStatus] = useState();
  const [boolStatus, setBoolStatus] = useState(false);
  useEffect(() => {
    if (keycloakService.isLoggedIn()) {
      dispatch(
        getJoyRideStatus((res) => {
          setStatus(res);
        })
      );
    }
    setStatus(true);
  }, []);
  useEffect(() => {
    if (status == '[open]') {
      setBoolStatus(true);
      setState((pre) => ({ ...pre, run: true }));
    }
  }, [status]);
  const [{ run, steps }, setState] = useState({
    run: boolStatus,
    steps: [
      {
        content: <h2>{t('lets_begin')}</h2>,
        locale: { skip: <strong>SKIP</strong> },
        placement: 'center',
        target: 'body'
      },
      {
        content: <h2>Exam Buy</h2>,
        placement: 'bottom',
        target: '#step-3',
        title: 'Click Exam Menu'
      }
    ]
  });
  const updateSteps = () => {
    setState((preValue) => ({
      ...preValue,
      steps: [
        {
          content: <h2>{t('lets_begin')}</h2>,
          locale: { skip: <strong>SKIP</strong> },
          placement: 'center',
          target: 'body'
        },
        {
          content: <h2>{t('exam_buy')}</h2>,
          placement: 'bottom',
          target: '#step-3',
          title: t('click_exam_menu')
        }
      ]
    }));
  };
  const handleCallBack = (data) => {
    console.log('data', data);
    if (data.action == 'close') {
      dispatch(joyRideAttributeCreation());
    }
  };
  return (
    <div>
      <Joyride
        continuous
        callback={handleCallBack}
        run={run}
        steps={steps}
        scrollToFirstStep
        showSkipButton
        showProgress
      />
      {props.children}
    </div>
  );
}

export default HomeJoyRide;
